export default "__VITE_ASSET__FJgrjnfH__"